import React, { useState, useEffect, useContext } from "react";
import { SidoSiggContext } from "../../contexts/SidoSiggContext";
import { CenterContext } from "../../contexts/CenterContext";

const CenterSearch = () => {
    const { sidos, siggs, sido, setSido } = useContext(SidoSiggContext);
    const { centerData, fetchCenterBySiggs } = useContext(CenterContext);
    const [selectedSigg, setSelectedSigg] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSidoChange = (e) => {
        setSido(e.target.value);  // 선택된 sido를 Context에 반영
        setSelectedSigg("");  // 시군구 초기화
    };

    const handleSiggChange = (e) => {
        setSelectedSigg(e.target.value);
    };

    const searchCenters = async () => {
        if (!sido || !selectedSigg) return;
        setLoading(true);

        try {
            await fetchCenterBySiggs(selectedSigg);
        } catch (error) {
            console.error("Error fetching centers:", error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="container px-5 my-5">
            <div className="text-center mb-5">
                <h1 className="display-5 fw-bolder mb-0"><span className="text-gradient d-inline">방문간호센터 검색</span></h1>
            </div>
            <div className="row gx-5 justify-content-center">
                <div className="col-lg-11 col-xl-9 col-xxl-8">
                    <div className="row d-flex align-items-center justify-content-between mb-4">
                        <div className=" d-flex align-items-center col-12 col-md-4 mb-2">
                            <select id="sido" className="form-control" value={sido} onChange={handleSidoChange}>
                                <option value="" disabled selected>시도 선택</option>
                                {sidos.map((sido) => (
                                    <option key={sido.adm_code} value={sido.adm_code}>{sido.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className=" col-12 col-md-4 mb-2">
                            <select id="sigg" className="form-control" value={selectedSigg} onChange={handleSiggChange} disabled={!sido}>
                                <option value="" disabled selected>시군구 선택</option>
                                {
                                    (siggs || []).map((sigg) => <option key={sigg.adm_code} value={sigg.adm_code}>{sigg.name}</option>)
                                }
                            </select>
                        </div>
                        <div className=" col-12 col-md-2 mb-2">
                            <button className="btn btn-primary w-100" type="button" onClick={searchCenters} disabled={!sido || !selectedSigg}>
                                검색
                            </button>
                        </div>
                    </div>
                    {!loading && centerData.length > 0 ? (
                        <div >
                            {centerData.map((center) =>
                                <div className="card shadow border-0 rounded-4 mb-5">
                                    <div className="card-body p-5">
                                        <div className="row align-items-center gx-5">
                                            <div className="col text-center text-lg-start mb-4 mb-lg-0">
                                                <div className="bg-light p-4 rounded-4">
                                                    <div className="text-center text-primary fw-bolder mb-2">{center.title}</div>
                                                    {/* <div className="text-center small text-muted">({center.center_id})</div> */}
                                                    <div className="text-center small fw-bolder"><a href={`tel:${center.phone_num_1st}`}>{center.phone_num_1st}</a></div>
                                                </div>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="small text-muted">{center.services}</div>
                                                <div>{center.address}</div>
                                                <div className="small text-muted"><a href={center.homepage} target="_blank" rel="noopener noreferrer">{center.homepage}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="card shadow border-0 rounded-4 mb-5">
                            <div className="card-body p-5">
                                <div className="row align-items-center gx-5">
                                    <div className="col text-center text-lg-start mb-4 mb-lg-0">
                                        <div className="bg-light p-4 rounded-4 align-items-center">
                                            <div className="text-primary fw-bolder text-center mb-2">
                                                {loading ? "검색중..." : "검색된 센터가 없습니다."}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </div>

    );
};

export default CenterSearch;
